import { createRoot } from "react-dom/client";
import { Suspense, lazy } from "react";
const CookieConsentApp = lazy(() => import("./CookieConsentApp"));

export const loadCookieConsent = async (document) => {
  if (!document) {
    return;
  }

  if (
    !document.location.search.match("forceCookies") &&
    document.documentElement?.getAttribute("data-consent") === "1"
  ) {
    return;
  }

  const cookieConsentRoot = document.createElement("div");
  document.body.appendChild(cookieConsentRoot);
  const root = createRoot(cookieConsentRoot);

  root.render(
    <Suspense fallback="">
      <CookieConsentApp standalone={true} />
    </Suspense>,
  );
};
